module.exports = __webpack_public_path__ + "static/hollywood-room-360-9564bb51bdeb56a2ec9db3701005f1f0.jpg";